import { timelineDuration } from '../../constants';

export const DEFAULT_SLOT_TITLE = 'Focus time';
export const LABEL_WIDTH = 50;
export const SLOT_HORIZONTAL_OFFSET = 18;
export const MIN_HOUR_ROW_HEIGHT = 46;
export const MIN_DAY_HEIGHT = MIN_HOUR_ROW_HEIGHT * (timelineDuration / 60);
